import React, { useState, useRef } from "react";

//interfaces
import { IAcknowledgementGroupModalProps } from "@/interfaces/acknowledgements";

//components
import ErrorMessage from "@/components/elements/global/ErrorMessage";



const AcknowledgementGroupModal = ({ isCreateGroupModal, groupName, setGroupName, modalClassName, onCancelClick, showErrorMessage, setShowErrorMessage, errorMessage }: IAcknowledgementGroupModalProps) => {

  const formRef = useRef(null);
  const [editableGroupName, setEditableGroupName] = useState(groupName);

  const handleInputChange = (e: any) => {
    setShowErrorMessage(false);
    setEditableGroupName(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); 
      formRef.current.dispatchEvent(new Event("submit"));
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setGroupName(editableGroupName);
  };

  return (
    <div className={`${modalClassName} acknowledgement-group-modal-container ${showErrorMessage ? "show-error" : ""}`}>
        <div data-testid="title" className="acknowledgement-group-modal-title">
            {isCreateGroupModal ? "Create Group" : "Edit Group Name"}
        </div>

        {showErrorMessage &&
          <ErrorMessage className={"something-went-wrong-error"} errorMessage={errorMessage} />
        }

        {isCreateGroupModal && (
            <div className="create-group-information">
                This will create a group from users that have completed acknowledgement, and will be updated when a new user does so.
            </div>
        )}

        <form onSubmit={handleSubmit} ref={formRef} onKeyPress={handleKeyPress} >
          <label htmlFor="group-name" className="group-name-label">GROUP NAME:</label>
          <input 
              id="group-name"
              type="text" 
              className={`group-name-input ${showErrorMessage ? "error-input" : ""}`}
              onChange={handleInputChange}
              value={editableGroupName || ''} 
              placeholder="Group Name"
          />

          <div className="acknowledgement-group-modal-buttons">
              <button className="cancel-button" aria-label="Cancel" onClick={onCancelClick} >
                Cancel
              </button>

              <button className="confirm-button" aria-label="Confirm" type="submit">
                Confirm
              </button>
          </div>
        </form>
    </div>
  );
};

export default AcknowledgementGroupModal;
